import React from 'react';
import { Container, Row, Col, Input, Label} from 'reactstrap';

class ClientTeam extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editEmployee: 0,
        };

    }

    render() {
        this.props.info('ClientTeam.js/render');
        return (
            <Container className="text-left" fluid>
                <Row>
                    <Col md={3} className="pr-1">
                        <Label className="w-100">Team<Input
                            type="select"
                            onChange={(e) => this.props.handleUpdateClientInfo(this.props.clientId, { team: parseInt(e.target.value) > 0 ? parseInt(e.target.value) : null })}
                            value={this.props.isFieldNull(this.props.clientData.team)}
                        >   <option value="">Select</option>
                            {this.props.teams.filter(team => team.active).map(team => (
                                <option key={team.id} value={team.id}>{team.teamName}</option>
                            ))}
                        </Input></Label>
                    </Col>
                    <Col md={3} className="pr-1">
                        <Label className="w-100">Account Owner<Input
                            type="select"
                            onChange={(e) => this.props.handleUpdateClientInfo(this.props.clientId, { employeePrimaryContact: parseInt(e.target.value) > 0 ? parseInt(e.target.value) : null })}
                            value={this.props.isFieldNull(this.props.clientData.employeePrimaryContact)}
                        >   <option value="">Select</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) === parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                            <option value="">------</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) !== parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                        </Input></Label>
                    </Col>
                    <Col md={3} className="pr-1">
                        <Label className="w-100">Processor<Input
                            type="select"
                            onChange={(e) => this.props.handleUpdateClientInfo(this.props.clientId, { employeeProcessor: parseInt(e.target.value) > 0 ? parseInt(e.target.value) : null })}
                            value={this.props.isFieldNull(this.props.clientData.employeeProcessor)}
                        >   <option value="">Select</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) === parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                            <option value="">------</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) !== parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                        </Input></Label>
                    </Col>
                    <Col md={3} className="pr-0">
                        <Label className="w-100">Backup<Input
                            type="select"
                            onChange={(e) => this.props.handleUpdateClientInfo(this.props.clientId, { employeeSecondaryContact: parseInt(e.target.value) > 0 ? parseInt(e.target.value) : null })}
                            value={this.props.isFieldNull(this.props.clientData.employeeSecondaryContact)}
                        >
                            <option value="">Select</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) === parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                            <option value="">------</option>
                            {this.props.employees.filter(employee => parseInt(employee.teamMembership) !== parseInt(this.props.clientData.team)).map(employee => (
                                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.firstName} {employee.lastName}</option>
                            ))}
                        </Input></Label>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ClientTeam;